module.exports = __webpack_public_path__ + "08_long_gold.c866e6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_long_gold.png
// module id = Dn8B
// module chunks = 0